import React from 'react'
import { Description } from '../Description'

export const CheckboxWidget = function ({
  schema,
  id,
  value,
  disabled,
  readonly,
  label,
  autofocus,
  onBlur,
  onFocus,
  onChange,
  uiSchema
}: any) {
  const description = uiSchema?.['ui:description'] || schema?.description

  return (
    <>
      <label className="control-label">{label}</label>
      {description && <Description id={id} description={description} />}
      <input
        type="checkbox"
        id={id}
        checked={typeof value === 'undefined' ? false : value}
        disabled={disabled || readonly}
        autoFocus={autofocus}
        onChange={event => onChange(event.target.checked)}
        onBlur={onBlur && (event => onBlur(id, event.target.checked))}
        onFocus={onFocus && (event => onFocus(id, event.target.checked))}
      />
    </>
  )
}
